/** Simpele hex-validatie: #rrggbb. */
export function isHexColor(value: string | null | undefined): value is string {
    return !!value && /^#[0-9a-fA-F]{6}$/.test(value);
}

/** Kiest zwart of wit als leesbare tekstkleur op een gegeven hex-achtergrondkleur
 * (WCAG-achtige relatieve luminantie). */
export function readableTextColor(hex: string): string {
    const clean = hex.replace("#", "");
    if (clean.length !== 6) return "#ffffff";

    const r = parseInt(clean.slice(0, 2), 16) / 255;
    const g = parseInt(clean.slice(2, 4), 16) / 255;
    const b = parseInt(clean.slice(4, 6), 16) / 255;

    const toLinear = (c: number) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);
    const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

    return luminance > 0.5 ? "#0b0f10" : "#ffffff";
}
